import { Box, BoxProps } from '@apia/theme';
import { ReactNode, memo } from 'react';
import { useSortableListHandler } from './SortableListHandler';

export type TSortableListItem = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  additionalProps?: any;
  boxProps?: Omit<BoxProps, 'id'>;
  id: string;
  children: ReactNode;
};

export const SortableListItem = memo(
  ({ boxProps, id, children }: TSortableListItem) => {
    return (
      <Box
        {...boxProps}
        as={boxProps?.as ?? 'li'}
        className={`sortableList__item ${boxProps?.className ?? ''}`}
        draggable
        id={id}
        ref={useSortableListHandler().useItemEvents()}
      >
        {children}
      </Box>
    );
  },
);
